import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  operador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  buque: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viaje: { value: null, matchMode: FilterMatchMode.CONTAINS },
  eta: { value: null, matchMode: FilterMatchMode.DATE_IS },
  ultimoBuque: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ultimoNumeroViaje: { value: null, matchMode: FilterMatchMode.CONTAINS },
  relleno: { value: null, matchMode: FilterMatchMode.CONTAINS },
  grupoDeAsignacion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  armadorCodigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  agencia: { value: null, matchMode: FilterMatchMode.CONTAINS },
  temperatura: { value: null, matchMode: FilterMatchMode.CONTAINS },
  humedad: { value: null, matchMode: FilterMatchMode.CONTAINS },
  o2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  co2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  booking: { value: null, matchMode: FilterMatchMode.CONTAINS },
  exportador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  mercaderia: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destino1: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destino2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destino3: { value: null, matchMode: FilterMatchMode.CONTAINS },
  totalReserva: { value: null, matchMode: FilterMatchMode.CONTAINS },
  totalEstadoExport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  totalEstadoPreasignado: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  },
  pendientes: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
